import { inject, Injectable } from '@angular/core';
import { NovaPortalLibConfig } from './nova-portal-lib-config.interface';
import { LIB_CONFIG } from './nova-portal-lib-config.token';

@Injectable({
	providedIn: 'root'
})
export class NovaPortalLibConfigService {
	private config = inject<NovaPortalLibConfig>(LIB_CONFIG);

	public getConfig(): NovaPortalLibConfig {
		return this.config;
	}
}
